import AnimatedSection from "../../../components/base/AnimatedSection";

export default function CorporateStrip() {
  return (
    <section className="bg-brand-pearl py-12">
      <div className="max-w-7xl mx-auto px-6">
        <AnimatedSection>
          <div className="flex items-start gap-6">
            <div className="flex-shrink-0 w-1 h-full self-stretch" style={{ backgroundColor: "#E8150C", minHeight: "100%" }}></div>
            <p className="font-body text-brand-anthracite text-base leading-relaxed text-center max-w-4xl mx-auto">
              <strong>Fair Play Global</strong> ofrece un servicio integral de gestión deportiva y fiscal para ligas y competiciones amateurs. Nos encargamos de la coordinación de árbitros y colaboradores, así como de todos los procesos administrativos y de cumplimiento legal en los pagos deportivos, garantizando trazabilidad, seguridad jurídica y una experiencia deportiva de máxima calidad para organizadores y participantes.
            </p>
          </div>
        </AnimatedSection>
      </div>
    </section>
  );
}